import React from "react";

export interface CartHeaderState {
    isBlack: boolean;
    isOtg: boolean;
    isExpress: boolean;
    startAnimation: boolean;
    themeChange: boolean;
    showFinalState: boolean;
    hideTheme: boolean;
    showAnimation: boolean;
    isStatusSuccess: boolean;
    isBolt: boolean;
}

export interface CartHeaderContextValue {
    cartHeaderState: CartHeaderState;
    setCartHeaderState: React.Dispatch<React.SetStateAction<CartHeaderState>>;
}

export const INITIAL_CART_HEADER_CONTEXT_VALUE: CartHeaderContextValue = {
    cartHeaderState: {
        isBlack: false,
        isOtg: false,
        isExpress: false,
        startAnimation: false,
        themeChange: false,
        showFinalState: false,
        showAnimation: false,
        hideTheme: false,
        isStatusSuccess: false,
        isBolt: false,
    },
    setCartHeaderState: () => void 0,
};

export const CartHeaderContext = React.createContext<CartHeaderContextValue>(INITIAL_CART_HEADER_CONTEXT_VALUE);

if (__DEV__) {
    CartHeaderContext.displayName = "CartHeaderContext";
}
